export enum MODE {
  IMAGE = 'image',
  VIDEO = 'video',
  URL = 'url',
}
